import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import fs from 'fs';
import http from 'http';
import https from 'https';
import util from 'util';
import { toArrayBuffer } from './utils/to-array-buffer.node';
import decodeDataUri from './utils/decode-data-uri.node';
import { concatenateReadStream } from './utils/stream-utils.node';
var DEFAULT_OPTIONS = {
  dataType: 'arraybuffer'
};

var isDataURL = function isDataURL(url) {
  return url.startsWith('data:');
};

var isRequestURL = function isRequestURL(url) {
  return url.startsWith('http:') || url.startsWith('https:');
};

export function readFile(_x) {
  return _readFile.apply(this, arguments);
}

function _readFile() {
  _readFile = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(url) {
    var options,
        _decodeDataUri,
        arrayBuffer,
        queryIndex,
        readFileAsync,
        buffer,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            options = getReadFileOptions(options);

            if (!isDataURL(url)) {
              _context.next = 5;
              break;
            }

            _decodeDataUri = decodeDataUri(url), arrayBuffer = _decodeDataUri.arrayBuffer;
            return _context.abrupt("return", Promise.resolve(arrayBuffer));

          case 5:
            if (!isRequestURL(url)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", new Promise(function (resolve, reject) {
              options = _objectSpread({}, new URL(url), {}, options);
              var request = url.startsWith('https:') ? https.request : http.request;
              request(url, function (response) {
                return concatenateReadStream(response).then(resolve, reject);
              });
            }));

          case 7:
            queryIndex = url && url.lastIndexOf('?');
            url = queryIndex >= 0 ? url.substr(0, queryIndex) : url;
            readFileAsync = util.promisify(fs.readFile);
            _context.next = 12;
            return readFileAsync(url, options);

          case 12:
            buffer = _context.sent;
            return _context.abrupt("return", buffer instanceof Buffer ? toArrayBuffer(buffer) : buffer);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _readFile.apply(this, arguments);
}

export function createReadStream(_x2, _x3) {
  return _createReadStream.apply(this, arguments);
}

function _createReadStream() {
  _createReadStream = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(url, options) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isDataURL(url)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", decodeDataUri(url));

          case 2:
            if (isRequestURL(url)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", fs.createReadStream(url, options));

          case 4:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              options = _objectSpread({}, new URL(url), {}, options);
              var request = url.startsWith('https:') ? https.request : http.request;
              request(url, function (response) {
                return resolve(response);
              });
            }));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createReadStream.apply(this, arguments);
}

function getReadFileOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  options = Object.assign({}, DEFAULT_OPTIONS, options);
  options.responseType = options.responseType || options.dataType;

  if (fs) {
    options.encoding = options.encoding || (options.dataType === 'text' ? 'utf8' : null);
  }

  return options;
}
//# sourceMappingURL=read-file.node.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/polyfills/dist/esm/fetch-node/read-file.node.js
// module id = 765
// module chunks = 0